module.exports = "/shifts/components/calendarRowUserComponent-96f991.html";